<template>
<v-card flat>
  <v-card-text>
    <v-row>
      <v-col cols=6 >
        <v-autocomplete dense
          :items="hourSlots(minStartTime)"
          v-model="startTime"
          label="Start time"
          class='ma-2'
          autocomplete >
        </v-autocomplete>
      </v-col>
      <v-col cols=6>
        <v-autocomplete dense
          :disabled='!startTime'
          :items="hourSlots(startTime)"
          v-model="endTime"
          label="End time"
          class='ma-2'
          autocomplete ></v-autocomplete>
      </v-col>
    </v-row>
  </v-card-text>
</v-card>
</template>
<script>
import {DateTime, Duration, Interval} from 'luxon'

export default {
  name: 'OperatingHours',
  props: {
    minStartTime: { type: String, default: '00:00' },
    initialStartTime: { type: String, default: null, required: false },
    initialEndTime: { type: String, default: null, required: false },
    initialPeriodInMins: { type: Number, default: 30, required: false },
    periodInMins: { type: Number, default: 15, required: false },
    value: { type: String, default: '' }
  },
  data () {
    return {
      startTime: null,
      endTime: null
    }
  },
  methods: {
    toMoment (timeString) {
      if (!timeString) { return DateTime.local() }
      if (!timeString.isLuxonDateTime) {
        let dt = DateTime.local().toISODate()
        return DateTime.fromISO(dt + ' ' + timeString)
      }
      return timeString
    },
    hourSlots (min) {
      /* example: min=08:00, max=17:00 */
      if (!min) { min = '00:00' }
      let dt = DateTime.local().toISODate()
      let start = DateTime.fromISO(dt + 'T' + min)
      let oneDay = Duration.fromObject({days: 1})
      let period = Duration.fromObject({minutes: this.periodInMins})
      let slots = Interval.fromISO(`${start}/${oneDay}`).splitBy(period)
      return slots.map((slot) => {
        return  slot.start.toLocaleString(DateTime.TIME_SIMPLE)
      })
    }
  },
  computed: {
    timeRange () {
      if (this.startTime && this.endTime) {
        return `${this.startTime}-${this.endTime}`
      }
      return null
    }
  },
  watch: {
    timeRange () {
      if (this.timeRange) {
        this.$emit('input', this.timeRange)
      }
    },
    initialStartTime () {
      this.startTime = this.initialStartTime
    },
    initialEndTime () {
      this.endTime = this.initialEndTime
    },
    initialPeriodInMins () {
      this.periodInMins = this.initialPeriodInMins
    },
    startTime () {
      let startMoment = this.toMoment(this.startTime)
      let endMoment = this.toMoment(this.endTime)
      if (startMoment >= endMoment) {
        this.endTime = this.startTime
      }
    }
  }
}
</script>
